import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import Submenu from "./Submenu";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

/**
 * Permet d'afficher les liens d'une catégorie dans la Sidebar
 * @param {object} category - données d'une catégorie
 * @param {function} activeBtn - permet de définir sur un lien est ouvert ou fermer 
 * @param {object} index - permet de définir quel lien à été cliquer
 * @param {object} secondDrop - permet de définir si une sous catégorie est ouverte ou fermer
 * @param {object} handleSecondDrop - permet d'ouvrir ou fermer une sous catégorie
 * @param {object} thirdDrop - défini si un lien dans une sous catégorie est ouvert ou fermer 
 * @param {object} handleThirdDrop - permet de définir si un lien dans une sous catégorie est ouvert ou fermer 
 */

export default function Categorie({
  category,
  activeBtn,
  index,
  secondDrop,
  handleSecondDrop,
  thirdDrop,
  handleThirdDrop
}) {
  const { entrepriseRoles, user } = useContext(AuthContext);
  const {t} = useTranslation();
  
  const shouldDisplayMenu = category.role ? category.role.some((role) => {
      if (role === "ROLE_SUPERADMIN" && user.entrepriseId === 18 || user.entrepriseId === 27 && category.path === "/agentinsight") {
        return user.roles.includes("ROLE_SUPERADMIN");
      }
      return entrepriseRoles.includes(role);
  }) : true;

  return (
    <>
      {shouldDisplayMenu && !category.dontDisplay && (
        <div className="categorie-container">
        <span></span>
        <li
          className={`categorie-item ${
            secondDrop === `${activeBtn}${index}` ? "categorie-item_open" : ""
          }`}
        >
          {category.submenu ? (
            <a
              className="categorie-link"
              onClick={(id) => {
                handleSecondDrop(`${activeBtn}${index}`);
              }}
            >
              {" "}
              {t(category.title)}
              {category.icon && category.icon}{" "}
            </a>
          ) : category.path.includes("http") ? (
            <a
              href={category.path}
              target={"_blank"}
              className="categorie-link"
            >
              {t(category.title)}
            </a>
          ) : (
            <div className="categorie-link">
              <NavLink to={category.path}>{t(category.title)}</NavLink>
            </div>
          )}
          {category.submenu ? (
            <ul
              className={`submenu-list ${
                secondDrop === `${activeBtn}${index}` ? "submenu-list_open" : ""
              }`}
            >
              {" "}
              {category.submenu.map((submenu, index) => {
                return (
                  <Submenu
                    key={index}
                    submenu={submenu}
                    index={index}
                    secondDrop={secondDrop}
                    thirdDrop={thirdDrop}
                    handleThirdDrop={handleThirdDrop}
                  />
                );
              })}
            </ul>
          ) : null}
        </li>
        </div>
      )}
    </>
  );
}
